import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "token";
const PERSIST_KEY = "token_persist";

// Fallback-tolerant token read: whichever bucket the login chose.
const getToken = () => {
  const persist = localStorage.getItem(PERSIST_KEY);
  if (persist === "0") return sessionStorage.getItem(TOKEN_KEY);
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
};

const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(PERSIST_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
};

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    // Session expired -> kick to login (avoid a broken UI stuck on 401s)
    if (err?.response?.status === 401 && !err?.config?.url?.includes("/auth/login")) {
      const wasLoggedIn = !!getToken();
      clearToken();
      if (wasLoggedIn && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default client;

export function apiError(e) {
  if (e?.code === "ERR_NETWORK" || e?.message === "Network Error") {
    return "Can't reach the server. Check your connection and try again.";
  }
  if (e?.response?.status === 401) return "Your session expired. Please sign in again.";
  if (e?.response?.status === 403) return "You don't have permission to do that.";
  if (e?.response?.status === 500) return "Something went wrong on the server. Please try again.";
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return "Request failed";
}

export function downloadCsv(path, filename = "export.csv") {
  const token = getToken();
  return fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    });
}
